import { createFileRoute } from '@tanstack/react-router';
import PasswordResetTemplate from '@/features/agent/account/templates/PasswordResetTemplate';

export const Route = createFileRoute('/account/password/reset/$token')({
  component: PasswordResetPage,
});

function PasswordResetPage() {
  const { token } = Route.useParams();

  return <PasswordResetTemplate token={token} />;
}
